<template>
  <nav role="navigation" id="nav">
    <div class="nav-wrapper container">
      <div class="brand-logo">
        <a href="/" title="Inicio" rel="home">Ing. Obed Javier</a>
        <div class="slogan">Crear, Mejorar e Innovar... Hacemos tus sueños realidad</div>
      </div>

      <!-- Dropdowns (one per route that tenga children) -->
      <template v-for="(menu, idx) in menuItems" :key="'dd-' + (menu.routeName || idx)">
        <ul v-if="menu.children && menu.children.length" :id="dropdownId(menu, idx)" class="dropdown-content">
          <li v-for="child in menu.children" :key="child.routeName || child.path">
            <router-link :to="child.routeName ? { name: child.routeName } : child.path" :title="child.linkTitle">
              {{ child.label }}
            </router-link>
          </li>
        </ul>
      </template>

      <!-- Desktop menu -->
      <ul class="right hide-on-med-and-down">
        <li v-for="(menu, idx) in menuItems" :key="menu.path || idx">
          <template v-if="menu.children && menu.children.length">
            <!-- trigger del dropdown: abierto por hover, click en este elemento abre/ciñe el submenu -->
            <a class="dropdown-trigger" href="#" @click.prevent :data-target="dropdownId(menu, idx)" :title="'Mostrar submenu ' + menu.label">
              <!-- label navegable -->
              <router-link class="menu-label" :to="menu.routeName ? { name: menu.routeName } : menu.path" :title="menu.linkTitle">
                {{ menu.label }}
              </router-link>
              <i class="material-icons right">arrow_drop_down</i>
            </a>
          </template>
          <template v-else>
            <router-link :to="menu.routeName ? { name: menu.routeName } : menu.path" :title="menu.linkTitle">
              {{ menu.label }}
            </router-link>
          </template>
        </li>
      </ul>

      <!-- Mobile sidenav -->
      <ul id="nav-mobile" class="sidenav">
        <li v-for="(menu, idx) in menuItems" :key="'m-' + (menu.path || idx)" :class="{ active: isActiveRoute(menu) }">
          <template v-if="menu.children && menu.children.length">
            <ul class="collapsible">
              <li>
                <div class="collapsible-header" :title="menu.linkTitle">{{ menu.label }}</div>
                <div class="collapsible-body">
                  <ul>
                    <li v-for="child in menu.children" :key="child.path || child.routeName" :class="{ active: isChildActive(child) }">
                      <router-link :to="child.routeName ? { name: child.routeName } : child.path" :title="child.linkTitle">
                        {{ child.label }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </template>
          <template v-else>
            <router-link :to="menu.routeName ? { name: menu.routeName } : menu.path" :title="menu.linkTitle">
              {{ menu.label }}
            </router-link>
          </template>
        </li>
      </ul>

      <a href="#" data-target="nav-mobile" class="sidenav-trigger">
        <i class="material-icons">menu</i>
      </a>
    </div>
  </nav>
</template>

<script>
import { routes } from '@/router';

export default {
  name: 'HeaderSection',

  computed: {
    menuItems() {
      // Intentar varias fuentes de rutas: this.$router.options.routes, import routes, router.getRoutes()
      const routerOptions = this.$router && this.$router.options && Array.isArray(this.$router.options.routes) ? this.$router.options.routes : null;
      const imported = Array.isArray(routes) && routes.length ? routes : null;
      let source = routerOptions || imported;

      // Si aún no hay source, intentar getRoutes() y derivar top-level por profundidad de path
      if (!source && this.$router && typeof this.$router.getRoutes === 'function') {
        const flat = this.$router.getRoutes() || [];
        // seleccionar rutas con path de nivel 0 o 1 (ej. '/', '/about') y que no sean wildcard
        source = flat.filter(r => {
          if (!r.path) return false;
          if (r.meta && r.meta.hideFromHeaderMenu) return false;
          if (r.path.includes('*')) return false;
          const segs = r.path.split('/').filter(Boolean);
          return segs.length <= 1;
        });
      }

      if (!Array.isArray(source) || !source.length) return [];

      return source
        .filter(r => r.meta?.hideFromHeaderMenu !== true)
        .map(r => {
          // children preferidos: r.children cuando exista, si no, intentar derivar del flat list (omitido por simplicidad)
          const rawChildren = Array.isArray(r.children) ? r.children : [];
          const children = rawChildren
            .filter(c => c.meta?.hideFromHeaderMenu !== true)
            .map(c => ({
              label: c.name || c.meta?.title || c.path, // visible usa name primero
              routeName: c.name || null,
              path: c.path,
              linkTitle: c.meta?.title || '',
            }));
          return {
            label: r.name || r.meta?.title || r.path, // visible usa name primero
            routeName: r.name || null,
            path: r.path,
            linkTitle: r.meta?.title || '',
            children,
          };
        });
    },
  },

  methods: {
    dropdownId(menu, idx) {
      // generar id estable para cada dropdown
      return 'dropdown-' + (menu.routeName ? String(menu.routeName).replace(/\s+/g, '-') : idx);
    },

    // Devuelve true si la ruta actual coincide con el menu (o alguno de sus hijos)
    isActiveRoute(menu) {
      const cur = this.$route || {};
      const curPath = cur.path || '';
      const curName = cur.name || null;

      // comparar por nombre si existe
      if (menu.routeName && curName && menu.routeName === curName) return true;
      // comparar por path exacto
      if (menu.path && curPath && menu.path === curPath) return true;
      // comprobar children
      if (Array.isArray(menu.children)) {
        for (const c of menu.children) {
          if (c.routeName && curName && c.routeName === curName) return true;
          if (c.path && curPath && c.path === curPath) return true;
        }
      }
      return false;
    },

    // Comprueba si un child específico está activo (por nombre o path)
    isChildActive(child) {
      const cur = this.$route || {};
      const curPath = cur.path || '';
      const curName = cur.name || null;
      if (child.routeName && curName && child.routeName === curName) return true;
      if (child.path && curPath && child.path === curPath) return true;
      return false;
    },
  },
};
</script>
